import React, { Component } from "react";
import { Link } from "react-router-dom";
import buroRingLogo from 'assets/funnel/buro_ring.png';

class JobDatenschutz extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Datenschutz | Büroring Personalmanagement";
  }

  renderLogoHeader() {
    return (
      <div className="text-center py-3 border-bottom">
        <img src={buroRingLogo} alt="Büroring Personalmanagement" style={{ height: 60, objectFit: 'contain' }} />
      </div>
    );
  }

  renderFooter() {
    return (
      <div className="mt-auto border-top px-4 py-4 text-center text-muted small">
        <div className="fw-semibold text-dark">Powered by Ali_Christoph</div>
        <div className="text-muted mb-3">Ein Projekt von Ali_Christoph</div>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <Link target="_blank" rel="noopener noreferrer" to="/job/impressum" className="text-dark text-decoration-underline small">Impressum</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/agb" className="text-dark text-decoration-underline small">AGB</Link>
        </div>
        <div className="mt-2">
          <Link target="_blank" rel="noopener noreferrer" to="/job/datenschutz" className="text-dark text-decoration-underline small">Datenschutzerklärung</Link>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="d-flex flex-column min-vh-100 bg-white" style={{ maxWidth: 480, margin: '0 auto' }}>
        {this.renderLogoHeader()}

        <div className="px-4 py-4 flex-grow-1">
          <h2 className="fw-bold mb-2">Datenschutzerklärung</h2>
          <p className="text-muted small mb-4">Ali_Christoph</p>

          <p className="small text-muted mb-4">
            Aus Gründen der besseren Lesbarkeit wird in der nachstehenden Erklärung auf die gleichzeitige
            Verwendung der Sprachformen männlich, weiblich oder divers verzichtet. Sämtliche
            Personenbezeichnungen gelten gleichermaßen für alle Geschlechter.
          </p>

          <section className="mb-4">
            <h6 className="fw-bold">1. Grundlegendes</h6>
            <p className="small">
              Der Schutz Ihrer personenbezogenen Daten ist uns ein besonderes Anliegen. Wir verarbeiten
              Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2021).
              In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der
              Datenverarbeitung im Rahmen unserer Applikation.
            </p>
          </section>

          <section className="mb-4">
            <h6 className="fw-bold">2. Datenschutzrechtlich Verantwortliche</h6>
            <p className="small mb-1">Ali_Christoph</p>
            <p className="small mb-1">[Straße und Hausnummer]</p>
            <p className="small mb-1">[PLZ] [Stadt], Österreich</p>
            <p className="small mb-1">Telefon: [+XX XXX XXXXXXX]</p>
            <p className="small">E-Mail: [datenschutz@example.com]</p>
          </section>

          <section className="mb-4">
            <h6 className="fw-bold">3. Verarbeitungstätigkeiten</h6>

            <p className="small fw-semibold mt-3 mb-1">3.1 Zugriffsdaten aus der Applikationsnutzung</p>
            <p className="small">
              Bei der Nutzung unserer Applikation werden automatisch technische Informationen erfasst,
              darunter Browsertyp, Betriebssystem, IP-Adresse, Zugriffszeit und Referrer-URL.
              Diese Daten werden für maximal 7 Tage gespeichert und dienen ausschließlich der Sicherstellung
              des technischen Betriebs. Bei Verdacht auf missbräuchliche Nutzung können diese Daten
              länger aufbewahrt werden.
            </p>

            <p className="small fw-semibold mt-3 mb-1">3.2 Bewerberdaten</p>
            <p className="small">
              Im Rahmen des Bewerbungsprozesses verarbeiten wir folgende Datenkategorien:
            </p>
            <ul className="small">
              <li>Kontaktdaten (Name, E-Mail-Adresse, Telefonnummer)</li>
              <li>Berufserfahrung und Berufsausbildung</li>
              <li>Spezielle Kenntnisse und Qualifikationen</li>
              <li>Angaben zur Verfügbarkeit</li>
              <li>Optionale Angaben (LinkedIn-Profil etc.)</li>
            </ul>
            <p className="small">
              Die Daten nicht ausgewählter Bewerber werden nach sechs Monaten gelöscht.
              Mit Ihrer ausdrücklichen Einwilligung können Ihre Daten bis zu zwei Jahre gespeichert
              werden, um Sie auch für zukünftige passende Stellenangebote zu kontaktieren.
            </p>
            <p className="small">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) sowie
              Art. 6 Abs. 1 lit. a DSGVO (Einwilligung für erweiterte Speicherung).
            </p>

            <p className="small fw-semibold mt-3 mb-1">3.3 Technisch notwendige Cookies</p>
            <p className="small">
              Ohne eine gesonderte Einwilligung werden bei fortgesetzter Nutzung unserer Applikation
              ausschließlich technisch notwendige Cookies auf Ihrem Endgerät gespeichert, welche die
              grundlegende technische Funktion der Applikation gewährleisten. Diese Cookies sind für
              den Betrieb der Seite erforderlich und können nicht deaktiviert werden.
            </p>

            <p className="small fw-semibold mt-3 mb-1">3.4 Google Fonts</p>
            <p className="small">
              Wir verwenden Google Fonts zur einheitlichen Darstellung von Schriftarten.
              Die Fonts werden lokal auf unserem Server gehostet. Es findet keine Verbindung
              zu Google-Servern statt.
            </p>

            <p className="small fw-semibold mt-3 mb-1">3.5 Analyse des Nutzerverhaltens</p>
            <p className="small">
              Mit Ihrer Einwilligung verwenden wir Analyse-Tools (z.B. Google Analytics, Meta-Pixel)
              zur Auswertung des Nutzerverhaltens, um unsere Applikation laufend zu verbessern.
              Die dabei erhobenen Daten werden für maximal 24 Monate gespeichert.
              Sie können Ihre Einwilligung jederzeit widerrufen.
            </p>
          </section>

          <section className="mb-4">
            <h6 className="fw-bold">4. Datenweitergabe</h6>
            <p className="small">
              Ihre Daten werden ausschließlich an den jeweiligen Auftraggeber (das suchende Unternehmen)
              weitergegeben, soweit dies für die Durchführung des Bewerbungsprozesses erforderlich ist.
              Eine Weitergabe an sonstige Dritte erfolgt nicht, es sei denn, dies ist gesetzlich
              vorgeschrieben oder Sie haben ausdrücklich eingewilligt.
            </p>
          </section>

          <section className="mb-4">
            <h6 className="fw-bold">5. Ihre Rechte als betroffene Person</h6>
            <p className="small">Ihnen stehen grundsätzlich folgende Rechte zu:</p>
            <ul className="small">
              <li className="mb-1"><strong>Auskunftsrecht</strong> (Art. 15 DSGVO)</li>
              <li className="mb-1"><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO)</li>
              <li className="mb-1"><strong>Recht auf Löschung</strong> (Art. 17 DSGVO)</li>
              <li className="mb-1"><strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
              <li className="mb-1"><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
              <li className="mb-1"><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO)</li>
              <li className="mb-1"><strong>Recht auf Widerruf der Einwilligung</strong> (Art. 7 Abs. 3 DSGVO)</li>
            </ul>
            <p className="small mt-2">
              Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt
              oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind,
              haben Sie die Möglichkeit, Beschwerde bei der Datenschutzbehörde einzureichen:
            </p>
            <p className="small">
              Österreichische Datenschutzbehörde<br />
              Barichgasse 40–42, 1030 Wien<br />
              Telefon: +43 1 52 152-0<br />
              E-Mail: dsb@dsb.gv.at
            </p>
          </section>

          <section className="mb-4">
            <h6 className="fw-bold">6. Kontakt in Datenschutzfragen</h6>
            <p className="small">
              Für Anfragen zum Datenschutz wenden Sie sich bitte an:<br />
              E-Mail: [datenschutz@example.com]
            </p>
          </section>

          <section className="mb-4">
            <h6 className="fw-bold">7. Aktualität und Änderung dieser Datenschutzerklärung</h6>
            <p className="small">
              Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer
              Applikation oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es
              notwendig werden, diese Datenschutzerklärung zu ändern.
            </p>
          </section>
        </div>

        {this.renderFooter()}
      </div>
    );
  }
}

export default JobDatenschutz;
